"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const hooks_1 = require("../../hooks");
const index_1 = require("../index");
function InviteButton({ groupId, userId, label }) {
    const sharingService = (0, hooks_1.useSharing)();
    const onInvite = () => {
        /**
         * If userId is -1, that means we need to invite the user by email
         */
        if (userId !== -1) {
            sharingService === null || sharingService === void 0 ? void 0 : sharingService.inviteToGroup(groupId, userId);
        }
        else {
            sharingService === null || sharingService === void 0 ? void 0 : sharingService.inviteByEmail(label, groupId);
        }
    };
    return ((0, jsx_runtime_1.jsx)(index_1.StyledMemberButton, { onClick: onInvite, "data-e2e": 'InviteButton_StyledMemberButton', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.invite) }));
}
exports.default = InviteButton;
